/*
 *
 * OtpPopup
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 18-Jul-2025
*/

import OtpPopup from './OtpPopupContainer'

export default OtpPopup
